import * as React from "react";
import ImageTextCtaList from "@/ReactComponents/ImageTextCtaList/image-text-cta-list";

const ImageTextCtaListView = props => <ImageTextCtaList {...props} />;

export default ImageTextCtaListView;
